<script>
import { Line } from 'vue-chartjs'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import Moment from 'moment'
import { mapGetters } from 'vuex'
import { widgetMixins } from '@/shared/WidgetMixins'

export default {
  extends: Line,
  mixins: [widgetMixins],
  components: {
    hexToRgba,
    CustomTooltips
  },

    ...mapGetters([
    'startDate',
    'endDate',
    'compareStartDate',
    'compareEndDate'
    ]),

  data () {
    return {
      datasets: [],
      labels: [],
      tooltipLabels: [],
      multiYAxis: false,
      disableDataComparison: false
    }
  },


  methods: {
    createChart () {
      if (this.$store.getters.compareStartDate === null) {
        if (Moment(this.labels[0]).isValid() === false) {
          this.renderChart(
            {
              datasets: this.datasets,
              labels: this.labels,
              tooltipLabels: this.tooltipLabels
            },
            {
              scales: {
                  yAxes: this.getYAxes(),
                  xAxes: [{
                      type: 'category',
                      ticks: {
                        autoSkip: false
                      }
                  }]
              },
              legend: {
                display: !this.disableLegend
              },
              responsive: true,
              maintainAspectRatio: false,
              tooltips: {
                enabled: false,
                custom: CustomTooltips,
                intersect: true,
                mode: 'index',
                position: 'nearest',
                callbacks: {
                  labelColor: function (tooltipItem, chart) {
                    return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
                  },
                  label: function(tooltipItem, chart) {
                    if (Array.isArray(chart.tooltipLabels[tooltipItem.datasetIndex])) {
                      return chart.tooltipLabels[tooltipItem.datasetIndex][tooltipItem.index] + ' - ' + tooltipItem.yLabel
                    } else {
                      return chart.tooltipLabels[tooltipItem.datasetIndex] + ' - ' + tooltipItem.yLabel
                    }
                  }
                }
              }
            }
          )
        } else {
          this.renderChart(
            {
              labels: this.labels,
              datasets: this.datasets,
              tooltipLabels: this.tooltipLabels
            },
            {
              scales: {
                  yAxes: this.getYAxes(),
                  xAxes: [{
                      type: 'time',
                      time: {
                        tooltipFormat: "MMMM D, YYYY",
                        minUnit: 'day',
                        displayFormats: {
                          day: "ll"
                        }
                      }
                  }]
              },
              legend: {
                display: !this.disableLegend
              },
              responsive: true,
              maintainAspectRatio: false,
              tooltips: {
                enabled: false,
                custom: CustomTooltips,
                intersect: true,
                mode: 'point',
                position: 'nearest',
                callbacks: {
                  labelColor: function (tooltipItem, chart) {
                    return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
                  },
                  label: function(tooltipItem, chart) {
                    if (Array.isArray(chart.tooltipLabels[tooltipItem.datasetIndex])) {
                      return chart.tooltipLabels[tooltipItem.datasetIndex][tooltipItem.index] + ' - ' + tooltipItem.yLabel
                    } else {
                      return chart.tooltipLabels[tooltipItem.datasetIndex] + ' - ' + tooltipItem.yLabel
                    }
                  }
                }
              }
            }
          )
        }
      } else {
        if (this.disableDataComparison){
          if (this.datasets.length === 2) {
            this.datasets[0].label = this.datasets[0].label+ ' - ' + this.$store.getters.startDate
            this.datasets[1].label = this.datasets[1].label + ' - ' + this.$store.getters.startDate
          }
        } else {
          this.addDateToLabel()
        }
        this.renderChart(
          {
            labels: this.labels,
            datasets: this.datasets,
            tooltipLabels: this.tooltipLabels
          },
          {
            scales: {
                yAxes: this.getYAxes(),
                xAxes: [{
                    ticks: {
                      callback: function(value) {
                        var firstDate = value.split('/')[0]
                        var secondDate = value.split('/')[1]
                        var newLabel = []
                        if (Moment(firstDate[0]).isValid() === true) {
                          newLabel.push(Moment(firstDate).format('ll') + ' vs')
                          newLabel.push(Moment(secondDate).format('ll'))
                          return newLabel
                        } else {
                          return firstDate
                        }
                      }
                    }
                }]
            },
            legend: {
              display: !this.disableLegend
            },
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
              enabled: false,
              custom: CustomTooltips,
              intersect: true,
              mode: 'index',
              position: 'nearest',
              callbacks: {
                labelColor: function (tooltipItem, chart) {
                  return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
                },
                label: function(tooltipItem, chart) {
                  if (Array.isArray(chart.tooltipLabels[tooltipItem.datasetIndex])) {
                    return chart.tooltipLabels[tooltipItem.datasetIndex][tooltipItem.index] + ' - ' + tooltipItem.yLabel
                  } else {
                    return chart.tooltipLabels[tooltipItem.datasetIndex] + ' - ' + tooltipItem.yLabel
                  }
                }
              }
            }
          }
        )
      }
    }
  }
}
</script>
